<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <button
          v-for="(tab, index) in taboption"
          :key="tab.name"
          class="nav-link"
          :class="index == 0 ? 'active' : ''"
          :id="`nav-${tab.name}-tab`"
          data-bs-toggle="tab"
          :data-bs-target="`#nav-${tab.name}`"
          type="button"
          role="tab"
          :aria-controls="`nav-${tab.name}`"
          aria-selected="true"
        >
          {{ tab.name }}
        </button>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-for="(tab, index) in taboption"
        :key="tab"
        class="tab-pane fade show"
        :class="index == 0 ? 'active' : ''"
        :id="`nav-${tab.name}`"
        :aria-labelledby="`nav-${tab.name}-tab`"
        role="tabpanel"
      >
        <component :is="tab.component" :payload="tab.payload"></component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["taboption"],
};
</script>

<style></style>
